module.exports = __webpack_public_path__ + "img/restarted.ba9aaaf4.svg";